import axios from 'axios'
import { cleanBlankValue } from 'utils/helper'

export const getFinanceWareHouses = (params) => {
  return axios.get('/finance/warehouses', { params })
}

export const getFinanceWareHouse = (id, params) => {
  return axios.get(`/finance/warehouses/${id}`, { params })
}

export const exportFinanceWarehouseDetail = (id, params) => {
  const exportParams = cleanBlankValue(params)
  return axios.get(`/finance/warehouses/${id}`, {
    params: exportParams,
    responseType: 'arraybuffer',
  })
}

export const deleteFinanceWareHousePhoto = (url) => {
  return axios.delete('/finance/warehouses/photo', { data: { url } })
}

export const deleteFinanceWareHousePhotoOnEdit = ({ url, id }) => {
  return axios.delete(`/finance/warehouses/${id}/photo`, { data: { url } })
}

export const getFinanceWareHouseLog = ({ id, params } = {}) => {
  return axios.get(`/finance/warehouses/${id}/logs`, { params })
}

export const getFinanceWareHouseTransactions = (id, params) => {
  return axios.get(`/finance/warehouses/${id}/transactions`, { params })
}

// BE minta is_canvas_warehouse berupa integer. Form antd (Checkbox) kirim boolean,
// jadi ubah ke Number di sini supaya semua jalur add/edit konsisten.
const normalizeCanvasWarehouse = (data) => {
  if (!data || !('is_canvas_warehouse' in data)) {
    return data
  }

  return { ...data, is_canvas_warehouse: Number(data.is_canvas_warehouse) }
}

export const addFinanceWareHouse = (data) => {
  return axios.post('/finance/warehouses', normalizeCanvasWarehouse(data))
}

export const editFinanceWareHouse = (data) => {
  return axios.put(`/finance/warehouses/${data.id}`, normalizeCanvasWarehouse(data))
}

export const moveFinanceWareHouse = (srcId, destId) => {
  return axios.patch(`/finance/warehouses/${srcId}/move`, { dest_id: destId })
}

export const activateFinanceWareHouse = (id) => {
  return axios.patch(`/finance/warehouses/${id}/activate`)
}

export const deactivateFinanceWareHouse = (id) => {
  return axios.patch(`/finance/warehouses/${id}/deactivate`)
}

export const getFinanceWareHouseTransfers = (_params) => {
  const params = cleanBlankValue(_params)
  return axios.get(`/finance/warehouses/transfers`, { params })
}

export const exportFinanceWarehouseTransfers = (params) => {
  return axios.get('/finance/warehouses/transfers', { responseType: 'arraybuffer', params })
}

export const getFinanceWareHouseTransfer = (id, params) => {
  return axios.get(`/finance/warehouses/transfers/${id}`, { params })
}

export const getFinanceWareHouseTransferLog = ({ id, params } = {}) => {
  return axios.get(`/finance/warehouses/transfers/${id}/logs`, { params })
}

export const addFinanceWareHouseTransfer = (data) => {
  return axios.post('/finance/warehouses/transfers', data)
}

export const editFinanceWareHouseTransfer = (data) => {
  return axios.put(`/finance/warehouses/transfers/${data.id}`, data)
}

export const deleteFinanceWareHouseTransfer = (id) => {
  return axios.delete(`/finance/warehouses/transfers/${id}`)
}

export const deleteOnAddFinanceWareHouseTransferAttachment = (url) => {
  return axios.delete('/finance/warehouses/transfers/attachments', { data: { url } })
}

export const deleteOnEditFinanceWareHouseTransferAttachment = (id, url) => {
  return axios.delete(`/finance/warehouses/transfers/${id}/attachments`, { data: { url } })
}

export const uploadImportFinanceWarehouseTransfer = (data) => {
  return axios.postForm('/finance/warehouses/transfers/uploadImport', data)
}

export const executeImportFinanceWarehouseTransfer = (data) => {
  return axios.post('/finance/warehouses/transfers/executeImport', data)
}

export const deleteFinanceWareHouse = (id) => {
  return axios.delete(`/finance/warehouses/${id}`)
}

export const archiveFinanceWareHouse = (id) => {
  return axios.patch(`/finance/warehouses/${id}/archive`)
}

export const unarchiveFinanceWareHouse = (id) => {
  return axios.patch(`/finance/warehouses/${id}/unarchive`)
}

export const getFinanceWarehouseRoles = (id) => {
  return axios.get(`/finance/warehouses/${id}/roles`)
}

export const addFinanceWarehouseRoles = (id, data) => {
  return axios.post(`/finance/warehouses/${id}/roles`, data)
}

export const approveWarehouseTransfer = (id) => {
  return axios.post(`/finance/warehouses/transfers/${id}/approve`)
}

export const rejectWarehouseTransfer = ({ id, body }) => {
  return axios.post(`/finance/warehouses/transfers/${id}/reject`, body)
}

export const revertWarehouseTransfer = ({ id }) => {
  return axios.post(`/finance/warehouses/transfers/${id}/revert`)
}

export const getFinanceWareHouseTransferGroups = (_params) => {
  const params = cleanBlankValue(_params)
  return axios.get('/finance/warehouses/transfers/groups', { params })
}

export const getFinanceWareHouseTransferGroup = (id, params) => {
  return axios.get(`/finance/warehouses/transfers/groups/${id}`, { params })
}

export const approveWareHouseTransferGroup = (id) => {
  return axios.post(`/finance/warehouses/transfers/groups/${id}/approve`)
}

export const rejectWareHouseTransferGroup = ({ id, body }) => {
  return axios.post(`/finance/warehouses/transfers/groups/${id}/reject`, body)
}

export const revertWareHouseTransferGroup = ({ id }) => {
  return axios.post(`/finance/warehouses/transfers/groups/${id}/revert`)
}

// Notifikasi global dibungkam: error 422 dipasang ke field form dan error bisnis
// ditampilkan sendiri oleh container. Lihat komentar opt-out di `utils/axios.js`.
export const addFinanceWareHouseTransferGroup = (data) => {
  return axios.post('/finance/warehouses/transfers/groups', data, {
    skipErrorNotification: true,
  })
}

export const editFinanceWareHouseTransferGroup = (data) => {
  return axios.put(`/finance/warehouses/transfers/groups/${data.id}`, data, {
    skipErrorNotification: true,
  })
}

export const deleteFinanceWareHouseTransferGroup = (id) => {
  return axios.delete(`/finance/warehouses/transfers/groups/${id}`)
}

export const addFinanceWarehouseContactGroups = (id, data) => {
  return axios.post(`/finance/warehouses/${id}/contactGroups`, data)
}

export const getWarehousesSummary = () => {
  return axios.get('/finance/warehouses/summary')
}

export const getRacks = (id) => {
  return axios.get(`/finance/warehouses/${id}/racks`)
}

export const addRack = ({ id, data }) => {
  return axios.post(`/finance/warehouses/${id}/racks`, data)
}

export const updateRack = ({ id, rackId, data }) => {
  return axios.patch(`/finance/warehouses/${id}/racks/${rackId}`, data)
}

export const deleteRack = ({ id, rackId }) => {
  return axios.delete(`/finance/warehouses/${id}/racks/${rackId}`)
}

export const getWarehouseSummaryById = (id) => {
  return axios.get(`/finance/warehouses/${id}/summary`)
}

export const getWarehousePinnedProducts = (id) => {
  return axios.get(`/finance/warehouses/${id}/pinnedProducts`)
}

export const pinWarehouseProducts = (id, data) => {
  return axios.post(`/finance/warehouses/${id}/pinnedProducts`, data)
}

export const unpinWarehouseProduct = (id, productId) => {
  return axios.delete(`/finance/warehouses/${id}/pinnedProducts/${productId}`)
}
